import Cookies from "js-cookie";

const AMPLIFY_AUTH_COOKIE_PREFIX = "CognitoIdentityServiceProvider.";
const SESSION_SCOPE_COOKIES = ["x-org-id", "x-team-id"];

export function clearLocalSessionCookies(): void {
  for (const name of Object.keys(Cookies.get())) {
    if (name.startsWith(AMPLIFY_AUTH_COOKIE_PREFIX)) Cookies.remove(name, { path: "/" });
  }
  for (const name of SESSION_SCOPE_COOKIES) Cookies.remove(name, { path: "/" });
}
